<template>
  <hic-list-page ref="listPage" title="患者列表" :show-model-switch="condition.state == '已入住'" :card-model="condition.state == '已入住' && meta.cardModel" @cardModelChange="meta.cardModel=$event" :card-col-span="6" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" header-height="6rem" keyword-placeholder="姓名、住院号、床位号">
    <template slot="buttons">
      <el-button type="primary" size="mini" icon="el-icon-document-add">打印</el-button>      
    </template>
    <template slot="search">
      <el-date-picker @change="dateChange" style="width: 270px" size="small" v-model="condition.date" type="daterange" range-separator="至" start-placeholder="入院日期" end-placeholder="结束日期"></el-date-picker>
    </template>
    <template slot="extend">
      <el-tabs v-model="tabName" @tab-click="page">
        <el-tab-pane label="费用" name="feiyong"></el-tab-pane>
        <el-tab-pane label="药品" name="drug"></el-tab-pane>
      </el-tabs>
    </template>
    <el-table-column label="姓名" prop="patientName" align="center">
      <template slot-scope="{ row }">
        <el-link type="primary" @click="inPatient(row, true)">
          <h3>{{ row.patientName }}</h3>
        </el-link>
      </template>
    </el-table-column>
    <el-table-column align="right" label="年龄" prop="patientAge"></el-table-column>
    <el-table-column label="单位" prop="patientName" align="center"></el-table-column>
    <el-table-column align="center" label="性别" prop="patientGender">
      <template slot-scope="{ row }">{{ row.patientGender | dictText("Gender") }}</template>
    </el-table-column>
    <el-table-column label="住院号" prop="patientName" align="center"></el-table-column>
    <el-table-column label="住院科室" prop="patientName" align="center"></el-table-column>
    <el-table-column label="住院病区" prop="deptCode" align="center">
      <template slot-scope="{ row }">
        {{ row.wardCode | dictText("IpWard") }}
      </template>
    </el-table-column>
    <el-table-column label="办案人" prop="patientName" align="center"></el-table-column>
    <el-table-column label="办案单位" prop="patientName" align="center"></el-table-column>
    <el-table-column label="费用总额" prop="patientName" align="center"></el-table-column>

    <el-table-column key="bedNo" v-if="condition.state == '已入住'" align="center" sortable="custom" label="床位" prop="bedNo"> </el-table-column>
    <el-table-column key="nursingGrade" align="center" v-if="condition.state == '已入住'" label="护理级别" prop="nursingGrade">
      <template slot-scope="{ row }">
        <el-tag v-if="row.nursingGrade" type="warning" size="small" hit>{{ row.nursingGrade }}</el-tag>
      </template>
    </el-table-column>
  </hic-list-page>
</template>
<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  // import utils from "@/common/utils"
  export default {
    components: {
      // "patient-card": () => import("./card/layout.vue"),
    },
    data() {
      return {
        tabName:'fee',
        meta: {
          showOper: false,
          showDaily: false,
          showPay: false,
          loading: false,
          showPaint: false,
          cardModel: false,
        },
        condition: {
          state: "已入住",
          ifShowOwnDept: true,
          date: "",
          keyword: "",
          pageSize: 10,
        },
        entities: {},
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "getDict", "dictEnum", "Enum", "permission", "user"]),
    },
    watch: {},
    created() {
      // this.page();
    },
    mounted() {},
    methods: {
      dateChange() {},
      inPatient(row, bol) {
        this.entity = row;
        this.meta.showPaint = bol;
      },
      page() {
        try {
          this.meta.loading = true;
          (() => {
            if (this.condition.state == "会诊") {
              let con = this.$utils.Obj.clone(this.condition);
              delete con.state;
              return api.Consultation.query(con);
            }
            this.condition.deptCode = this.user.deptCode;
            return api.Hospitalization.query(this.condition);
          })()
            .then((res) => {
              this.entities = res;
            })
            .catch((err) => {
              this.$message.error(err.message || err);
            });
        } catch (err) {
          this.$message.error(err.message || err);
        } finally {
          this.meta.loading = false;
        }
      },
      inDays(val) {
        let days = this.$utils.Dt.span(val, new Date(), "d");
        let years = Math.trunc(days / 365);
        days = days % 365;
        return years ? `${years}年${days}天` : `${days}天`;
      },
    },
  };
</script>
